import { Action, DispatchFunc } from "frontend/state/actions";
import { Board, BoardPermission, BoardState as BoardStateEnum } from "shared/datamodel/schemas/board";
import {
  createBoard as internalCreateBoard,
  deleteBoard as internalDeleteBoard,
  editBoard as internalEditBoard,
  moveBoard as internalMoveBoard,
  duplicateBoard as internalDuplicateBoard,
  fetchBoard,
  getBoards,
  getPasswordProtectedBoard,
} from "../api";
import { BlankCanvasId } from "shared/datamodel/schemas";
import tracking from "frontend/tracking";
import { isCIM } from "utils/url-utils";
import { getAccessPermissionToMondayBoard } from "./monday-api-service";
import { getInitialBoard } from "utils/server-props-cache";

export async function loadBoards(dispatch: DispatchFunc) {
  dispatch({ type: Action.LoadingBoards, payload: null });
  try {
    const boards = await getBoards();
    dispatch({ type: Action.UpdatedBoards, payload: boards });
  } catch {
    dispatch({ type: Action.FailedLoadingBoards, payload: null });
  }
}

export async function deleteBoard(dispatch: any, board: Board) {
  dispatch({ type: Action.DeleteBoard, payload: board.documentId });
  try {
    await internalDeleteBoard(board.documentId);
  } catch {
    dispatch({ type: Action.FailedDeleteBoard, payload: board });
  }
}

export async function duplicateBoard(dispatch: any, board: Board) {
  const { board: newBoard, contents } = await internalDuplicateBoard(board.documentId);
  dispatch && dispatch({ type: Action.CreatedBoard, payload: newBoard });
  return { documentId: newBoard.documentId, contents };
}

export async function editBoard(dispatch: any, board: Board, oldBoard: Board) {
  dispatch({ type: Action.EditedBoard, payload: board });
  try {
    const res = await internalEditBoard(board);
    return res;
  } catch {
    dispatch({ type: Action.FailedEditBoard, payload: oldBoard });
  }
}

export async function moveBoard(dispatch: any, board: Board, oldBoard: Board) {
  dispatch({ type: Action.EditedBoard, payload: board });
  try {
    const res = await internalMoveBoard(board);
    return res;
  } catch {
    dispatch({ type: Action.FailedEditBoard, payload: oldBoard });
  }
}

export async function createBoard({
  name,
  state,
  templateIdOrAlias,
  projectId,
  teamId,
  dispatch,
}: {
  name: string;
  state: BoardStateEnum | null;
  templateIdOrAlias: string | null;
  projectId: string | null;
  teamId: string | null;
  dispatch?: any;
}): Promise<Board> {
  templateIdOrAlias = templateIdOrAlias !== BlankCanvasId ? templateIdOrAlias : null;
  const board = await internalCreateBoard({
    name,
    templateIdOrAlias,
    state: state ?? BoardStateEnum.default,
    projectId,
    teamId,
  });
  console.log("internalCreateBoard", { board, state, createdFromTemplateId: templateIdOrAlias });
  dispatch && dispatch({ type: Action.CreatedBoard, payload: board });
  return board;
}

export async function createBoardNew(
  name: string,
  state: BoardStateEnum | null,
  templateIdOrAlias: string | null,
  projectId: string | null,
  teamId: string | null,
  dispatch?: any
): Promise<Board> {
  templateIdOrAlias = templateIdOrAlias !== BlankCanvasId ? templateIdOrAlias : null;
  const board = await internalCreateBoard({
    name,
    templateIdOrAlias,
    state: state ?? BoardStateEnum.default,
    projectId,
    teamId,
    boardMondayInfoId: null,
    permission: BoardPermission.private,
  });
  dispatch && dispatch({ type: Action.CreatedBoard, payload: board });
  return board;
}

export async function loadBoard(dispatch: DispatchFunc, documentId: string, password?: string) {
  dispatch({ type: Action.LoadingSpecificBoard, payload: documentId });
  let data: { board: Board; templateElements: any; authToken?: string };
  if (password) {
    data = await getPasswordProtectedBoard(documentId, password);
  } else {
    data = getInitialBoard() ?? (await fetchBoard(documentId));
  }

  await loadMondayUserBoardAccess(dispatch);
  dispatch({ type: Action.LoadedSpecificBoard, payload: data.board });
  return data;
}

async function loadMondayUserBoardAccess(dispatch: DispatchFunc) {
  if (isCIM()) {
    const mondayBoardAccessPermission = await getAccessPermissionToMondayBoard();
    tracking.trackAnalyticsEvent("canvas_monday_board_access", {
      mondayBoardaccessPermission: mondayBoardAccessPermission,
    });
    dispatch({ type: Action.UpdateMondayUserBoardAccess, payload: mondayBoardAccessPermission });
  }
}
